<template>
  <a-layout-content class="p-all overflow-hidden">
    <a-card class="h-full d-flex flex-column nowrap">
      <span slot="title">KERJA PRAKTEK BARU</span>
      <a-steps class="steps-list" :current="current" status="process">
        <a-step title="Profil" />
        <a-step title="Dokumen" />
        <a-step title="Kegiatan"/>
        <a-step title="NDA"/>
      </a-steps>
      <div class="steps-content flex-1">
        <keep-alive>
          <component :is="steps[current].content" :collectedData="dataContainer" :datamaster="datamaster" :mode="mode" :ref="stepRef"></component>
        </keep-alive>
      </div>
      <template slot="actions">
        <div class="steps-action">
          <a-button v-if="current < steps.length - 1" type="primary" @click="next">Next</a-button>
          <a-button
            :loading="btnLoading"
            v-if="current == steps.length - 1"
            type="primary"
            @click="validate"
          >Save</a-button>
          <a-button v-if="current>0" @click="prev">Previous</a-button>
        </div>
      </template>
    </a-card>
  </a-layout-content>
</template>

<script>
import Profile from "./steps/Profile";
import Document from "./steps/Document";
import Kegiatan from "./steps/Kegiatan";
import NDA from "./steps/nda";
import moment from "moment";
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  name: "createKaryawan",
  props: ["tlc"],
  components: {
    Profile,
    Document,
    Kegiatan,
    NDA
  },
  data() {
    return {
      current: 0,
      btnLoading: false,
      steps: [],
      dataContainer: {},
      datamaster:{},
      mode: "create"
    };
  },
  computed: {
    ...mapGetters(["getAuth", "getStandartFormatDate"]),
    stepRef: function() {
      let ref = "";
        if (this.steps[this.current].content === "Profile") {
          ref = "refProfile";
        } else if (this.steps[this.current].content === "Document") {
          ref = "refDocument";
        } else if (this.steps[this.current].content === "Kegiatan") {
          ref = "refKegiatan";
        } else if (this.steps[this.current].content === "NDA") {
          ref = "refNDA";
        }
      return ref;
    }
  },
  created() {
    if (this.tlc) {
      this.Fetch_EditedId();
      this.mode = "edit";
    }
    this.steps = [
      {
        title: "Profile",
        content: "Profile"
      },
      {
        title: "Document",
        content: "Document"
      },
      {
        title: "Kegiatan",
        content: "Kegiatan"
      },
      {
        title: "NDA",
        content: "NDA"
      }
    ];
  },
  methods: {
    moment,
    next() {
      if (this.steps[this.current].content === "Profile") {
        this.$refs.refProfile.handleRef();
      } else if (this.steps[this.current].content === "Document") {
        this.$refs.refDocument.handleRef();
      } else if (this.steps[this.current].content === "Kegiatan") {
        this.$refs.refKegiatan.handleRef();
      }
    },
    prev() {
      this.current--;
    },
    validate() {
      this.$refs.refNDA.handleRef();
    },
    submit() {
      this.btnLoading = true;
      let postData = new FormData();

      postData.append("nama_lengkap", this.dataContainer.profile.nama);
      postData.append("alamat", this.dataContainer.profile.alamat);
      postData.append("no_telp", this.dataContainer.profile.telpon?this.dataContainer.profile.telpon:"");
      postData.append("tempat_lahir", this.dataContainer.profile.tempat_lahir);
      postData.append("tanggal_lahir", this.moment(this.dataContainer.profile.tgl_lahir).format(this.getStandartFormatDate));
      postData.append("email", this.dataContainer.profile.email?this.dataContainer.profile.email:"");
      postData.append("jenis_kelamin", this.dataContainer.profile.gender);
      postData.append("jenis_identitas", this.dataContainer.profile.jenis_identitas);
      postData.append("nomor_identitas", this.dataContainer.profile.no_identitas);
      postData.append("kelas", this.dataContainer.document.jenjang);
      postData.append("jurusan", this.dataContainer.document.jurusan);
      postData.append("guru", this.dataContainer.document.guru);
      postData.append("id_sekolah", this.dataContainer.document.sekolah);
      postData.append("alamat_sekolah", this.dataContainer.document.alamat);
      if(this.dataContainer.document.noTelp)
      postData.append("telp_sekolah", this.dataContainer.document.noTelp_code+this.dataContainer.document.noTelp);
      postData.append("jenis_kegiatan", this.dataContainer.kegiatan.jenis_kegiatan);
      postData.append("unit_kegiatan", this.dataContainer.kegiatan.unit_kegiatan);
      postData.append("pembimbing", this.dataContainer.kegiatan.pembimbing);
      postData.append("tanggal_mulai", this.moment(this.dataContainer.kegiatan.tglmasuk).format(this.getStandartFormatDate));
      postData.append("tanggal_selesai", this.moment(this.dataContainer.kegiatan.tglselesai).format(this.getStandartFormatDate));
      postData.append("signature", this.dataContainer.nda.signature);
      postData.append("document_support", this.dataContainer.document.doc.file);
      postData.append("foto_karyawan", this.dataContainer.profile.foto[0]);

      let url = "";
      if (this.mode == "create") {
        url = this.$serviceUrl + "internship";
      } else {
        url = this.$serviceUrl + "internship/edit";
      }

      axios({
        method: "post",
        url: url,
        processData: false,
        data: postData,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.displayMessage("success-edit");
          this.btnLoading = false;
          this.$router.push({ name: "master.siswa" });
        })
        .catch(err => {
          this.btnLoading = false;
        });
    },
    dataBucket(value) {
      console.log("dataBucket", value)
      if (this.steps[this.current].content === "Profile") {
        this.dataContainer.profile = value;
        this.current++;
      } else if (this.steps[this.current].content === "Document") {
        this.dataContainer.document = value;
        if (this.mode == "create") {
          this.current++;
        } else {
          this.confirmMessage("confirm-edit");
        }
      } else if (this.steps[this.current].content === "Kegiatan") {
        this.dataContainer.kegiatan = value;
        this.current++;
      } else if (this.steps[this.current].content === "NDA") {
        this.dataContainer.nda = value;
        this.confirmMessage("confirm-save");
      } 
    },
    async Fetch_EditedId() {
      await axios({
        method: "get",
        url: this.$serviceUrl + "master_karyawan/detail_edit",
        params: {
          tlc: this.tlc,
          "X-API-KEY": this.getAuth.apikey
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        }
      })
        .then(response => {
          this.data = response.data;
        })
        .catch(err => {
          console.log(err.response);
        });
    },
    getDatamaster(){
      axios({
        method: "get",
        url: this.$serviceUrl + "internship/create",
        params: {},
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.datamaster = response.data
        })
        .catch(err => {
          console.log(err.response);
        });
    }
  },
  mounted() {
    if (this.tlc) {
      this.Fetch_EditedId();
      this.mode = "edit";
    }

    this.getDatamaster()

    Event.$on("createKaryawan", this.dataBucket);
    Event.$on("confirmMessageEdit", this.submit);
    Event.$on("confirmMessageReturn", this.submit);
  },
  beforeDestroy() {
    Event.$off("createKaryawan", this.dataBucket);
    Event.$off("confirmMessageEdit", this.submit);
    Event.$off("confirmMessageReturn", this.submit);
  }
};
</script>

<style>
</style>
